<template>
    <div class="message-content">
        <el-tabs :tab-position="tabPosition" @tab-click="handleTabClick" v-model="tabName" type="border-card">
          <!-- 全部类型消息 -->
          <el-tab-pane class="content-total" name="first" label="预警消息">
              <WarnMessageTable 
                ref="dynamicTable1"
                :pageData="pageData"
                :page="page"
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
          </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="消息简要"
            append-to-body
            :visible.sync="isShowDetail">
            <el-form  :model="messageInfo" size="mini" label-width="120px" class="message-form">
                <el-form-item label="消息类型:" prop="msgTitle">
                    <el-tag type="danger">预警消息</el-tag>
                </el-form-item>
                <el-form-item label="消息标题:" prop="msgTitle">
                    <!-- <div class="message-item-pre message-item-content">
                        {{messageInfo.msgTitle}}
                    </div> -->
                    <el-input readonly  v-model="messageInfo.msgTitle"></el-input>
                </el-form-item>
                <el-form-item label="消息内容:" prop="msgContent">
                    <!-- <div style="white-space: pre-line;" class="message-item-pre message-item-content">
                        {{messageInfo.msgContent}}
                    </div> -->
                    <el-input readonly type="textarea" style="width:99%" :rows="6"  v-model="messageInfo.msgContent"></el-input>
                </el-form-item>
                <el-form-item v-if="messageInfo.linkedUrl" label="访问详情" prop="linkedUrl">
                    <div style="cursor:pointer;" @click.stop="linkToDetailPage()">
                        <span class="message-item-pre tag-link span-line">点击进入</span>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getWarnMessageList, updMessage, deleteMessage, updAllMessageStatus, delAllMessage } from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';
import WarnMessageTable from './WarnMessageTable';
export default {
    mixins: [ mixinsNav ],
    // register the component
    components: {
        WarnMessageTable
    },
    data () {
        return {
            tabName: 'first',
            tabPosition: 'top',
            tableHeight: '460px',
            isShowDetail: false,
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            tableLoading: false,
            pageData: [],
            tableColumns: [
                {
                    id: '1',
                    prop: 'msgTitle',
                    label: '消息标题'
                },
                {
                    id: '2',
                    prop: 'sendTime',
                    label: '产生时间'
                },
                {
                    id: '3',
                    prop: 'msgTypeView',
                    label: '消息类型'
                }
            ],
            searchParams: {
                msgStatus: null // 消息阅读状态 null全部 0未读 1已读
            },
            messageInfo: {
                msgTitle: '',
                msgContent: '',
                linkedUrl: ''
            },
            messageParam: {
                msgflag: 1,
                msgType: ''
            }
        };
    },
    props: {
        // msgType: { // 消息类型
        //     type: Number
        // },
        msgStatus: { // 消息阅读状态
            type: Number
        },
        isShowUpdAllBtn: {
            type: Boolean,
            default: false
        }
    },
    created () {
        this.initData();
    },
    methods: {
        initData () {
            this.queryTableData(this.page);
        },
        handleTabClick (tab, event) {
            this.queryTableData(this.page);
        },
        queryTableData ({currentPage}) {
            this.page.currentPage = currentPage;
            this.renderTableList(this.selectedModel);
        },
        async renderTableList () {
            this.tableLoading = true;
            this.searchParams.msgStatus = this.msgStatus;
            let formData = await getWarnMessageList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            this.pageData = formData.data;
            // console.log(this.isSubform);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
        },
        async handleMessageDelete (row) {
            this.$confirm(`您确定要删除当前消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                await deleteMessage(row.id);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        linkPage (row) {
            updMessage(row);
            // this.navigateTo(row.linkedUrl);
            // this.navMessage(row.id);
            this.messageInfo = row;
            this.isShowDetail = true;
            setTimeout(() => { // 更新navbar上消息红点
                this.$parent.$parent.$children[0].setWarnMessageHot();
            }, 0);
        },
        async linkToDetailPage () {
            this.isShowDetail = false;
            sessionStorage.setItem('isShowDiagram', true);
            this.navigateTo(this.messageInfo.linkedUrl);
        },
        async handleAllMessageDelete (msgType) {
            this.$confirm(`您确定要删除所有消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                // console.log(msgType);
                this.messageParam.msgType = msgType;
                await delAllMessage(this.messageParam);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        async handleAllMessageRead (msgType) {
            this.$confirm(`您确定要所有未读消息标为已读吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                this.messageParam.msgType = msgType;
                await updAllMessageStatus(this.messageParam);
                await this.queryTableData(this.page);

                setTimeout(() => { // 更新navbar上消息红点
                    this.$parent.$parent.$children[0].setWarnMessageHot();
                }, 0);
            }).catch(() => {});
        }
    }
};
</script>

<style>
  .message-content{
      width: 100%;
  }
  .message-item-pre{
      padding-left: 10px;
      margin-left:14px;
  }
  .message-item-content{
      width: 360px;
      border: 1px solid #ebebeb;
      border-radius: 3px;
      transition: .2s;
      background: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
  }
  .span-line{
      color:rgb(19, 206, 102);
  }
  .span-line:hover{
      text-decoration:underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/WarnMessage/WarnMessage.vue